































































































































































import { Component, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, getInstallList, installsSend, installsDel } from '@/api/admin'
import conFirm from './confirm.vue'
import router from '../../router'

@Component({
  components: {
    conFirm
  }
})
export default class Install extends ViewBase {
  loading = true
  errMsg = ''
  total = 0
  page = 1
  pageSize = 10
  list = null
  editItem = {}
  delItem = {}
  editVisible = false
  delVisible = false
  title = ''
  resType = ''
  resTypeList = []
  needStatus = ''
  phaseList = []
  subjectList = []
  dresType = {}
  dphase = {}
  dsubject = {}
  pagination: any = {}
  columns: any = []
  searchkey = ''
  lang = {}
  expandedRowKeys: any = []
  selectedRowKeys: any = []
  doc: any
  visible1 = false
  visible2 = false
  installid = []
  allDeviceIds = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  created() {
    this.doc = window.document
    this.lang = this.i18n.vInstall
    const lang: any = this.lang
    this.columns = [
       {
        title: '',
        dataIndex: 'cover',
        className: 'texcenter width80',
        scopedSlots: { customRender: 'image' }
      },
      {
        title: lang.name,
        className: 'colName',
        dataIndex: 'title'
      },
      {
        title: lang.installed,
        className: 'colnum',
        dataIndex: 'doneCount'
      },
      {
        title: lang.installing,
        className: 'colnum',
        dataIndex: 'beingCount'
      },
      {
        title: lang.installFail,
        className: 'colnum',
        dataIndex: 'failCount'
      },
      {
        title: lang.uninstall,
        className: 'colnum',
        dataIndex: 'pendCount'
      },
      {
        title: lang.operation,
        dataIndex: 'operation',
        className: 'texcenter wid370',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.getType()
  }
  async getType() {
    try {
      const { data } = await getCateList()
      // console.log('获取学科接口', data)
      const resTypeList: any = []
      const dsubject: any = []
      const phaseList: any = []
      const dphase: any = []
      const dresType: any = []

      data.res_type.map((item: any) => {
        dresType[item.id] = item.name
        resTypeList.push(item)
      })
      data.phase.map((item: any) => {
        dphase[item.id] = item.name
        phaseList.push(item)
        item.subject.map((subject: any) => {
          dsubject[subject.id] = subject.name
        })
      })

      this.resTypeList = resTypeList
      this.dsubject = dsubject
      this.dphase = dphase
      this.dresType = dresType
      this.phaseList = phaseList
      this.fetch({
        page: 1,
        res_type: 0,
        phase: 0,
        subject: 0,
        key: ''
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  changegeres_type(dd: any) {
    // console.log(dd)
    this.resType = dd
    this.fetch({
      page: 1,
      res_type: this.resType,
      phase: 0,
      subject: 0,
      key: this.searchkey
    })
  }
  searcha(val: any) {
    // console.log(val)
    this.searchkey = val
    this.fetch({
      page: 1,
      res_type: this.resType,
      phase: 0,
      subject: 0,
      key: this.searchkey
    })
  }
  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager

    this.fetch({
      page: pagination.current,
      res_type: this.resType,
      phase: 0,
      subject: 0,
      key: this.searchkey
    })
  }

  async fetch(params: any = {}) {
    // console.log('params:', params)
    this.loading = true

    try {
      const { data } = await getInstallList(params)

      const pagination: any = { ...this.pagination }
      // Read total count from server
      // pagination.total = data.totalCount;
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.pagination = pagination

      const rids: any = data.list.length > 0 ? data.list[0].deviceList : []
      const allDeviceIds: any = []
      if (rids) {
        rids.map((item: any) => {
          allDeviceIds.push(item.id)
        })
      }
      this.allDeviceIds = allDeviceIds
    } catch (ex) {
        this.handleError(ex)
    }
  }
  changegUrl_type(dd: any) {
    // console.log(dd)
    if (dd == 0) {
    } else {
      localStorage.setItem('page-installdev' , '1')
      this.$router.push({
        name: 'installdev',
        query: { page: '0' }
      })
    }
  }
  onSelectChange(selectedRowKeys: any) {
    // console.log('selectedRowKeys changed: ', selectedRowKeys)
    this.selectedRowKeys = selectedRowKeys
  }
  info(item: any) {
    let dd = []
    dd.push(item.id)
    if (this.expandedRowKeys[0] == item.id) {
      dd = []
    }
    this.expandedRowKeys = dd
  }
  // 各种展示提交操作
  cancelMod() {
    this.visible1 = false
    this.visible2 = false
  }

  oninstallshow(item: any) {
    const id: any = []
    id.push(item.id)
    this.visible1 = true
    this.installid = id
  }
  uninstallshow(item: any) {
    const id: any = []
    id.push(item.id)
    this.visible2 = true
    this.installid = id
  }
  allupdateshow() {
    const id: any = Object.assign([], this.selectedRowKeys)
    // console.log(this.selectedRowKeys)
    if (this.selectedRowKeys.length <= 0) {
      this.$message.error(this.i18n.vInstall.plasechose)
    } else {
      this.visible1 = true
      this.installid = id
    }
  }
  alluninstallshow() {
    const id: any = Object.assign([], this.selectedRowKeys)
    // console.log(this.selectedRowKeys)
    if (this.selectedRowKeys.length <= 0) {
      this.$message.error(this.i18n.vInstall.plasechose)
    } else {
      this.visible2 = true
      this.installid = id
    }
  }
  async oninstall() {
    const pdata: any = {
      rids: this.installid,
      ids: this.allDeviceIds
    }
    try {
      const res = await installsSend(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.visible1 = false
      this.selectedRowKeys = []
      this.fetch({
        page: this.pagination.current || 1,
        res_type: this.resType,
        phase: 0,
        subject: 0,
        key: this.searchkey
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  async uninstall() {
    const pdata: any = {
      rids: this.installid,
      ids: this.allDeviceIds
    }
    try {
      const res = await installsDel(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.visible2 = false
      this.selectedRowKeys = []
      this.fetch({
        page: this.pagination.current || 1,
        res_type: this.resType,
        phase: 0,
        subject: 0,
        key: this.searchkey
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  @Watch('$route')
  routechange(to: any, from: any) {
    if (to.name == 'install') {
      this.page = to.query.page
    }
  }
}
